import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import { customColors } from '../misc';
import { PageFooter } from './constants';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'Helvetica',
    color: '#1B1B1B',
  },
  frame: {
    border: `2pt solid ${customColors.BLUE} `,
    borderRadius: 8,
    padding: 28,
    height: '100%',
    justifyContent: 'space-between',
  },
  header: {
    alignItems: 'center',
    marginBottom: 20,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: customColors.BLUE,
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 10,
    color: '#555',
  },
  nameBlock: {
    marginTop: 30,
    marginBottom: 14,
    textAlign: 'center',
  },
  nameLabel: {
    fontSize: 10,
    color: '#666',
    marginBottom: 6,
    letterSpacing: 1.2,
  },
  personName: {
    fontSize: 28,
    fontWeight: 700,
  },
  requirementBlock: {
    textAlign: 'center',
    marginBottom: 24,
  },
  requirementText: {
    fontSize: 12,
  },
  requirementTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginTop: 4,
  },
  detailsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 12,
    marginBottom: 40,
  },
  detailsCol: {
    width: '48%',
  },
  label: {
    fontSize: 9,
    color: '#666',
    marginBottom: 4,
    letterSpacing: 1,
  },
  value: {
    fontSize: 12,
    fontWeight: 600,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: 'auto',
  },
  signatureBox: {
    width: '45%',
  },
  line: {
    height: 1,
    backgroundColor: '#bbb',
    marginTop: 24,
    marginBottom: 6,
  },
  sigLabel: {
    fontSize: 9,
    color: '#666',
    textAlign: 'center',
  },
  image: {
    height: 50,
    margin: '0 auto',
    padding: 5,
    width: 'auto',
  },
  spacer: {
    marginBottom: 20,
  },
});

const formatDate = (d) => {
  if (!d) return '—';
  const date = new Date(d);
  if (isNaN(+date)) return '—';
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
  });
};

export default function CertificatePDF({ certificate = {}, logo }) {
  const { user, title, expires, provider, description, dateIssued } =
    certificate || {};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.frame}>
          <Image style={styles.image} src={logo || '/blue_black_full.png'} />
          <View style={styles.header}>
            <Text style={styles.title}>Certificate of Completion</Text>
            <Text style={styles.subtitle}>This certifies that</Text>
          </View>
          <View style={styles.nameBlock}>
            <Text style={styles.nameLabel}>AWARDED TO</Text>
            <Text
              style={styles.personName}
            >{`${user?.firstName} ${user?.lastName}`}</Text>
          </View>
          <View style={styles.requirementBlock}>
            <Text style={styles.requirementText}>
              has successfully completed
            </Text>
            <Text style={styles.requirementTitle}>{title || '—'}</Text>
          </View>
          <View>
            <Text style={styles.label}>Training Provider</Text>
            <Text style={styles.value}>{provider}</Text>
          </View>
          <View style={styles.spacer} />
          <View>
            <Text style={styles.label}>Description</Text>
            <Text style={styles.value}>{description}</Text>
          </View>
          <View style={styles.spacer} />
          <View style={styles.detailsRow}>
            <View style={styles.detailsCol}>
              <Text style={styles.label}>ISSUED ON</Text>
              <Text style={styles.value}>{formatDate(dateIssued)}</Text>
            </View>
            <View style={styles.detailsCol}>
              <Text style={styles.label}>EXPIRES ON</Text>
              <Text style={styles.value}>{formatDate(expires)}</Text>
            </View>
          </View>
          <View style={styles.footer}>
            <View style={styles.signatureBox}>
              <View style={styles.line} />
              <Text style={styles.sigLabel}>Authorized Signature</Text>
            </View>
            <View style={styles.signatureBox}>
              <View style={styles.line} />
              <Text style={styles.sigLabel}>Recipient Signature</Text>
            </View>
          </View>
        </View>
        <PageFooter />
      </Page>
    </Document>
  );
}
